import React, {
    useState
  } from "react";
  
  import {
    Outlet
  } from "react-router-dom";
  
  import {
    FaBars
  } from "react-icons/fa";
  
  import AdminSidebar
    from "../components/AdminSidebar";
  
  import "../styles/AdminLayout.css";
  
  
  const AdminLayout = () => {
  
    const [
      sidebarOpen,
      setSidebarOpen
    ] = useState(false);
  
  
    const openSidebar = () => {
      setSidebarOpen(true);
    };
  
  
    const closeSidebar = () => {
      setSidebarOpen(false);
    };
  
  
    return (
      <div className="admin-layout">
  
        <AdminSidebar
          isOpen={sidebarOpen}
          onClose={closeSidebar}
        />
  
  
        {sidebarOpen && (
          <div
            className="admin-sidebar-overlay"
            onClick={closeSidebar}
          />
        )}
  
  
        <div className="admin-content-wrapper">
  
          <header className="admin-mobile-header">
  
            <button
              type="button"
              className="admin-mobile-menu-button"
              onClick={openSidebar}
              aria-label="Ouvrir le menu"
            >
              <FaBars />
            </button>
  
            <div className="admin-mobile-brand">
              <strong>
                CarrerUp
              </strong>
  
              <span>
                Administration
              </span>
            </div>
  
          </header>
  
  
          <main className="admin-main-content">
            <Outlet />
          </main>
  
        </div>
  
      </div>
    );
  };
  
  export default AdminLayout;